export type ActionTier = 'routine' | 'sensitive' | 'critical'

export interface MirrorAckEntry {
  acked_at: string
  external_ref: unknown
}

export interface AuditRow {
  id: string
  seq: number
  organization_id: string | null
  organization_slug: string | null
  actor_type: 'user' | 'pat' | 'system' | 'unauthenticated'
  actor_id: string | null
  actor_label: string | null
  actor_email: string | null
  action: string
  action_tier: ActionTier
  resource_type: string | null
  resource_id: string | null
  metadata: unknown
  ip: string | null
  user_agent: string | null
  trace_id: string | null
  prev_hash: string
  row_hash: string
  signature: string
  signing_key_id: string
  mirror_acks: Record<string, MirrorAckEntry>
  created_at: string
}

export interface MirrorStatus {
  id: string
  sync_tiers: ActionTier[]
  on_timeout: 'degrade' | 'fail'
  timeout_ms: number
  last_acked_seq: number
  last_attempt_at: string | null
  last_success_at: string | null
  last_error: string | null
  consecutive_errors: number
  lag: number
  healthy: boolean
}

export interface MirrorStatusPage {
  tip_seq: number
  mirrors: MirrorStatus[]
}

export interface MirrorVerifyResult {
  ok: boolean
  checked: number
  broken_at_seq: number | null
  reason: string | null
}

export interface AuditListPage {
  events: AuditRow[]
  next_cursor: number | null
}

export interface AuditVerifyResult {
  ok: boolean
  checked?: number
  tip_hash?: string
  broken_at_seq: number | null
  reason: string | null
}

export const ACTION_GROUPS: Record<string, string[]> = {
  auth: [
    'auth.login.succeeded',
    'auth.login.failed',
    'auth.logout',
    'auth.session.revoked',
    'auth.sessions.revoked_all',
    'auth.step_up.completed',
    'auth.step_up.cleared',
  ],
  webauthn: [
    'webauthn.credential.registered',
    'webauthn.credential.removed',
    'webauthn.credential.renamed',
  ],
  pat: ['pat.created', 'pat.revoked'],
  org: ['org.created', 'org.deleted', 'org.member.role_changed'],
  invite: ['invite.created', 'invite.revoked', 'invite.accepted'],
  repo: ['repo.created', 'repo.updated', 'repo.deleted'],
  policy: ['policy.created', 'policy.updated', 'policy.deleted'],
  package: [
    'package.version.state_transitioned',
    'package.files.yanked',
    'package.files.unyanked',
    'package.file.cache_cleared',
    'package.resynced',
    'package.deleted',
  ],
  system: [
    'system.setting.upserted',
    'system.user.active_changed',
  ],
}
